import { useAgreementsDispatch } from './agreements-context';
import PortalAppService from '../../../application/platform/portal-app-service';
import { IListAgreementsRequest } from '../../../model/base/request/list-agreements-request';

export function useAgreementsController() {
  const dispatch = useAgreementsDispatch();

  const loadAgreements = async (params: IListAgreementsRequest) => {
    dispatch({ type: 'LOAD_START' });
    try {
      const response = await PortalAppService.requestAgreements(params);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: 'LOAD_ERROR', payload: 'Erro ao carregar convênios e repasses.' });
    }
  };

  return { loadAgreements };
}
